"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = __importDefault(require("./context"));
var context_2 = __importDefault(require("../Map/context"));
function DrawingManager(props) {
    var map = React.useContext(context_2.default).map;
    var drawingManager = React.useMemo(function () {
        var options = {
            map: map,
            drawingMode: ["arrow", "circle", "ellipse", "marker", "polygon", "polyline", "rectangle"],
        };
        var $drawingManager = new kakao.maps.drawing.DrawingManager(options);
        return $drawingManager;
    }, []);
    var listeners = React.useRef({});
    listeners.current.onDrawend = function onDrawend(mouseEvent) {
        var _a;
        var data = drawingManager.getData();
        drawingManager.remove(mouseEvent.target);
        (_a = props.onDrawend) === null || _a === void 0 ? void 0 : _a.call(props, data[mouseEvent.overlayType][0]);
        if (props.shape === "none") {
            drawingManager.cancel();
        }
        if (props.shape !== "none") {
            drawingManager.select(props.shape);
        }
    };
    React.useEffect(function () {
        drawingManager.addListener("drawend", listeners.current.onDrawend);
        return function () {
            drawingManager.removeListener("drawend", listeners.current.onDrawend);
        };
    }, []);
    React.useLayoutEffect(function () {
        props.shape === "none"
            ? drawingManager.cancel()
            : drawingManager.select(props.shape);
    }, [props.shape]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "fillColor", props.fill);
    }, [props.shape, props.fill]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "fillOpacity", props.fillOpacity);
    }, [props.shape, props.fillOpacity]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "strokeColor", props.stroke);
    }, [props.shape, props.stroke]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "strokeWeight", props.strokeWidth);
    }, [props.shape, props.strokeWidth]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "strokeOpacity", props.strokeOpacity);
    }, [props.shape, props.strokeOpacity]);
    React.useEffect(function () {
        if (props.shape === "none")
            return;
        drawingManager.setStyle(props.shape, "hintStrokeStyle", props.hintStrokeStyle);
    }, [props.shape, props.hintStrokeStyle]);
    return (React.createElement(context_1.default.Provider, { value: { drawingManager: drawingManager } }, props.children));
}
DrawingManager.defaultProps = {
    shape: "none",
    fill: "#39f",
    fillOpacity: 0.3,
    stroke: "#39f",
    strokeOpacity: 1,
    strokeWidth: 3,
    strokeStyle: "solid",
    hintStrokeStyle: "dashdot",
    hintStrokeOpacity: 0.3,
};
DrawingManager.propTypes = {
    /** 그리기 모양 */
    shape: prop_types_1.default.oneOf(["marker", "rectangle", "circle", "ellipse", "polyline", "polygon", "arrow", "none"]),
    /** 선 색 (기본값: #39f) */
    stroke: prop_types_1.default.string,
    /** 선의 두께 (기본값: 3) */
    strokeWidth: prop_types_1.default.number,
    /** 보조선 스타일 */
    strokeStyle: prop_types_1.default.oneOf(["solid", "shortdash", "shortdot", "shortdashdot", "shortdashdotdot", "dot", "dash", "dashdot", "longdash", "longdashdot", "longdashdotdot"]),
    /** 선의 불투명도 (0-1, 기본값: 1.0) */
    strokeOpacity: prop_types_1.default.number,
    /** 채우기 색 (기본값: #39f) */
    fill: prop_types_1.default.string,
    /** 채우기 불투명도 (0-1, 기본값: 1.0) */
    fillOpacity: prop_types_1.default.number,
    /** 보조선 스타일 */
    hintStrokeStyle: prop_types_1.default.oneOf(["solid", "shortdash", "shortdot", "shortdashdot", "shortdashdotdot", "dot", "dash", "dashdot", "longdash", "longdashdot", "longdashdotdot"]),
    /** 보조선 불투명도 (0-1, 기본값: 1.0) */
    hintStrokeOpacity: prop_types_1.default.number,
    onDrawend: prop_types_1.default.func.isRequired,
};
exports.default = DrawingManager;
